import React, { memo } from 'react'
import moment from 'moment-timezone'
import Typography from 'transfix-ui/core/Typography'
import { IStops } from 'types/FMSGraphqlTypes'
import { stopDate, stopTimeShortNoTimeZone } from 'utils/appointmentHelpers'
import { FORMATS } from 'constants/datetime'

interface IStopDateTimeProps {
  stop: IStops
}

export const StopDateTime = memo<IStopDateTimeProps>(({ stop }) => {
  const { displayTimezone, endAt, startAt } = stop || {}
  const timezone = displayTimezone || 'America/New_York'
  const isBeforeCurrentYear = moment(startAt).isBefore(moment(), 'year')
  const appointmentDateFormat = isBeforeCurrentYear ? FORMATS.dayFormatYear : FORMATS.dayFormat
  const appointmentTime = `, ${stopTimeShortNoTimeZone(
    startAt,
    endAt,
    timezone,
    true,
    true,
    FORMATS.militaryTimeFormatShort12H,
    '-'
  )}`
  return (
    <Typography variant='body2' component='div'>
      {stopDate(startAt, timezone, appointmentDateFormat)}
      {!isBeforeCurrentYear && appointmentTime}
    </Typography>
  )
})
